import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const FAQList = ({ content }) => {
  const columns = content.faqColumn.map(column => (
    <Column>
      <ColumnHeader>{column.columnHeader}</ColumnHeader>
      {column.listItems.map(item => (
        <ListItem dangerouslySetInnerHTML={{ __html: item.listItemCopy }} />
      ))}
    </Column>
  ))
  return (
    <Wrapper>
      <IntroDiv>
        <IntroHeader>{content.introHeader}</IntroHeader>
        <IntroBody>{content.introBody}</IntroBody>
      </IntroDiv>
      <Columns>{columns}</Columns>
    </Wrapper>
  )
}

const ListItem = styled.div`
  ${text.bodySm};

  strong {
    ${text.bodyMdBold};
  }
`
const ColumnHeader = styled.div`
  ${text.bodyMdBold};
  border-bottom: 0.069vw solid ${colors.primaryOrange};

  ${media.fullWidth} {
    border-bottom: 1px solid ${colors.primaryOrange};
  }

  ${media.tablet} {
    border-bottom: 0.098vw solid ${colors.primaryOrange};
  }

  ${media.mobile} {
    border-bottom: 0.234vw solid ${colors.primaryOrange};
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.778vw;

  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.tablet} {
    gap: 3.906vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`
const Columns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.111vw;

  ${media.fullWidth} {
    gap: 16px;
  }

  ${media.tablet} {
    flex-direction: column;
    gap: 3.906vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 9.346vw;
  }
`
const IntroBody = styled.p`
  ${text.bodySm};
`
const IntroHeader = styled.h4`
  ${text.h4};

  ${media.mobile} {
    ${text.h4};
  }
`
const IntroDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.778vw;
  width: 79.444vw;

  ${media.fullWidth} {
    gap: 40px;
    width: 1144px;
  }

  ${media.tablet} {
    gap: 3.906vw;
    width: 92.188vw;
  }

  ${media.mobile} {
    gap: 9.346vw;
    width: 87.85vw;
  }
`
export default FAQList
